import { useEffect, useState } from "react";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { fetchApi } from '../../services/api';
import { ILink } from "../../types/link";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { Checkbox, TextArea } from "@progress/kendo-react-inputs";
import { Button } from "@progress/kendo-react-buttons";
import { JsonResponse } from "TypeGen/json-response";

type Props = {
  link: ILink;
  userId: string;
  close: () => void;
  refresh: () => void;
}

const AssignResolvePopup = ({ link, close, refresh, userId }: Props) => {
  const [saving, setSaving] = useState(false);
  const [note, setNote] = useState('');
  const [customerNotified, setCustomerNotified] = useState(false);
  const [forwardToOrderNote, setForwardToOrderNote] = useState(true);
  const [forwardToBillingNote, setForwardToBillingNote] = useState(false);
  const [selectedUser, setSelectedUser] = useState('');
  const [users, setUsers] = useState<Array<{ ID: string, Name: string }>>([]);

  useEffect(() => {
    fetchApi('/api/User/UsersDropdown')
      .then((data: { SelfID: string, Users: Array<{ ID: string, Name: string }>, SelectedReasonLate?: number | null }) => {
        setSelectedUser(userId || data.SelfID);
        setUsers(data.Users);
      });
  }, [link.Link, userId]);

  const mark = () => {
    setSaving(true);
    const payload = {
      UserID: selectedUser,
      Note: note,
      CustomerNotified: customerNotified,
      ForwardToOrderNote: forwardToOrderNote,
      ForwardToBillingNote: forwardToBillingNote
    };
    fetchApi(link.Link, payload, link.Method)
      .then((response: JsonResponse) => {
        if (response.Success) {
          refresh();
          close();
        } else {
          alert(response.ErrorMessage);
        }
      })
      .catch((e) => {
        // If not problem details
        if (!e?.status) alert('An error occurred while processing your request.');
      }).finally(() => setSaving(false));
  }

  const dataView = () => {
    return <>
      <DropDownList
        data={users}
        value={users.find(x => x.ID == selectedUser)}
        textField="Name"
        dataItemKey="ID"
        onChange={(e) => setSelectedUser(e.target.value.ID)}
      />
      <br /><br />
      <TextArea
        autoFocus
        value={note}
        placeholder="Add Note (optional)"
        onChange={(e) => setNote(e.value)}
      />
      <div className="mt-2">
        <Checkbox
          checked={forwardToOrderNote}
          label="FW: Order General Note"
          onChange={(e) => setForwardToOrderNote(e.value)}
        />
      </div>
      <div className="mt-2">
        <Checkbox
          checked={forwardToBillingNote}
          label="FW: Billing Note"
          onChange={(e) => setForwardToBillingNote(e.value)}
        />
      </div>
      <div className="mt-2">
        <Checkbox
          checked={customerNotified}
          label="Customer Notified"
          onChange={(e) => setCustomerNotified(e.value)}
        />
      </div>
    </>
  }

  return <Dialog
    title={link.Name}
    className="dialog-w525"
    onClose={close}
  >
    {dataView()}
    <DialogActionsBar>
      <Button disabled={saving} className="ml-auto" onClick={close}>
        Cancel
      </Button>
      {link.Name === "Assign" && <Button themeColor="primary" disabled={saving} onClick={mark}>
        Assign
      </Button>}
      {link.Name === "Reassign" && <Button themeColor="primary" disabled={saving} onClick={mark}>
        Reassign
      </Button>}
      {link.Name === "Resolve" && <Button themeColor="success" disabled={saving} onClick={mark}>
        Resolve
      </Button>}
    </DialogActionsBar>
  </Dialog>
}

export default AssignResolvePopup;
